import React from "react";
import './index.scss'

export default ({children, disable = false, action, type = 'default'}) => {
    return (
        <button type="submit" disabled={disable} className={`btn ${type} ${disable ? 'disable' : ''}`} onTouchStart={() => action && action()} onClick={() => action && action()}>{children}</button>
    )
}
